
document.addEventListener("DOMContentLoaded", function() {
console.log('test')
let quickAddDrawer = document.querySelector('.cart-item')
console.log(quickAddDrawer)
if (quickAddDrawer) {
    let observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
            if (m.addedNodes.length) {
               console.log('test 123')
            }
        });
    });
    observer.observe(quickAddDrawer, {
        childList: true
    });
}
});